import { useModel3dStore } from '../model3dStore.js'
import { isResourceUsed } from '../../utils/resourceUsage.js'

export const model3dResourceAdapter = {
  type: 'model3d',

  list() {
    return useModel3dStore().all
  },
  get(uuid) {
    return useModel3dStore().getModel(uuid)
  },
  remove(uuid) {
    return useModel3dStore().removeModel(uuid)
  },
  duplicate(uuid) {
    return useModel3dStore().duplicateModel(uuid)
  },
  rename(uuid, name) {
    return useModel3dStore().updateModel(uuid, { name })
  },
  isUsed(uuid, layer) {
    return isResourceUsed(layer, 'resource', uuid)
  },
  getDisplayName(uuid) {
    return useModel3dStore().getModel(uuid)?.name ?? null
  },
}
